import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SanitizeService {
    // remove ZWSP and non-printable characters
    sanitizeInput(value: string): string {
        //const zwspRegex = /[\u200B-\u200D\uFEFF\u00A0\u2028\u2029]/g;
        //const zwspRegex = /[\u200B-\u200D\uFEFF\u00A0\u2028\u2029]|[^A-Za-z0-9,&+\- ]/g;
        const zwspRegex = /[\u200B-\u200D\uFEFF\u00A0\u2028\u2029]|[^A-Za-z0-9,&+\-?.' ]/g;
        return value.replace(zwspRegex, '');
    }
}
